/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2TenMinuteIntervalIcon/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2TenMinuteIntervalIcon({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2TenMinuteIntervalIcon",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 10,
  height = 6,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#323F4B"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2TenMinuteIntervalIcon.Svg"
  data-view-path={viewPath}
 viewBox="0 0 10 6"
 style={{'--as-1-1EQAiC': alignSelf,'--mt-2-1EQAiC': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-1EQAiC': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-1EQAiC': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-1EQAiC': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-1EQAiC': opacity,'--w-10-1EQAiC': typeof width === 'number' ? `${width}px` : width,'--h-11-1EQAiC': typeof height === 'number' ? `${height}px` : height,'--f-12-1EQAiC': fill,'--a-7-1EQAiC': isAnimated ? animation : "none",'--sd-8-1EQAiC': isAnimated ? strokeDashoffset : 0,'--sd-9-1EQAiC': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2TenMinuteIntervalIcon.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M3.113.58a.502.502 0 10-1.005 0 .703.703 0 01-.704.704h-.402a.502.502 0 100 1.005h.402c.251 0 .49-.054.704-.151V4.9H1.002a.502.502 0 100 1.005h3.216a.502.502 0 100-1.005H3.113V.581zM6.285 1.753c0-.37.3-.67.67-.67h.87c.37 0 .67.3.67.67V4.23c0 .37-.3.67-.67.67h-.87a.67.67 0 01-.67-.67V1.753zm.67-1.675c-.925 0-1.675.75-1.675 1.675V4.23c0 .925.75 1.675 1.675 1.675h.87c.925 0 1.675-.75 1.675-1.675V1.753C9.5.828 8.75.078 7.825.078h-.87z"
 style={{'--f-12-1EQAiC': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}